/* AMOVA · comportamiento del tema (Shopify).
   El consentimiento de cookies se entrega a la API de privacidad del cliente de Shopify,
   que es la que decide si cargan los píxeles instalados como apps (Meta, Google). */

(function () {
  "use strict";

  var CLAVE = "amova_consentimiento_v1";

  function leerConsentimiento() {
    try {
      var bruto = window.localStorage.getItem(CLAVE);
      return bruto ? JSON.parse(bruto) : null;
    } catch (e) {
      return null;
    }
  }

  function guardarConsentimiento(valor) {
    var registro = {
      necesarias: true,
      analitica: !!valor.analitica,
      marketing: !!valor.marketing,
      fecha: new Date().toISOString(),
      version: 1
    };
    try {
      window.localStorage.setItem(CLAVE, JSON.stringify(registro));
    } catch (e) {
      /* Sin almacenamiento disponible: se respeta la elección solo en esta visita. */
    }
    return registro;
  }

  function informarAShopify(c) {
    if (!c || !window.Shopify || typeof window.Shopify.loadFeatures !== "function") return;
    window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (error) {
      if (error || !window.Shopify.customerPrivacy) return;
      window.Shopify.customerPrivacy.setTrackingConsent(
        {
          analytics: !!c.analitica,
          marketing: !!c.marketing,
          preferences: false,
          sale_of_data: !!c.marketing
        },
        function () {}
      );
    });
  }

  /* ---------- Aviso de cookies ---------- */
  var aviso = document.getElementById("cookies");
  if (aviso) {
    var ajustes = aviso.querySelector("[data-cookies-ajustes]");
    var casillaAnalitica = aviso.querySelector('input[name="analitica"]');
    var casillaMarketing = aviso.querySelector('input[name="marketing"]');
    var botonGuardar = aviso.querySelector('[data-cookies="guardar"]');
    var botonConfigurar = aviso.querySelector('[data-cookies="configurar"]');
    var origenFoco = null;

    var abrir = function (conAjustes) {
      var actual = leerConsentimiento();
      casillaAnalitica.checked = !!(actual && actual.analitica);
      casillaMarketing.checked = !!(actual && actual.marketing);
      ajustes.hidden = !conAjustes;
      botonGuardar.hidden = !conAjustes;
      botonConfigurar.hidden = !!conAjustes;
      aviso.hidden = false;
    };

    var cerrar = function (valor) {
      informarAShopify(guardarConsentimiento(valor));
      aviso.hidden = true;
      if (origenFoco) {
        origenFoco.focus();
        origenFoco = null;
      }
    };

    aviso.addEventListener("click", function (ev) {
      var boton = ev.target.closest("[data-cookies]");
      if (!boton) return;
      var accion = boton.getAttribute("data-cookies");
      if (accion === "aceptar") cerrar({ analitica: true, marketing: true });
      if (accion === "rechazar") cerrar({ analitica: false, marketing: false });
      if (accion === "guardar") cerrar({ analitica: casillaAnalitica.checked, marketing: casillaMarketing.checked });
      if (accion === "configurar") {
        abrir(true);
        casillaAnalitica.focus();
      }
    });

    document.addEventListener("click", function (ev) {
      var abridor = ev.target.closest("[data-abrir-cookies]");
      if (!abridor) return;
      ev.preventDefault();
      origenFoco = abridor;
      abrir(true);
      aviso.querySelector("h2").focus();
    });

    var previo = leerConsentimiento();
    if (previo) {
      informarAShopify(previo);
    } else {
      /* Hasta que la persona elija, se informa a Shopify que no hay consentimiento. */
      informarAShopify({ analitica: false, marketing: false });
      abrir(false);
    }
  }

  /* ---------- Selector de combos ---------- */
  var formulario = document.getElementById("formulario-compra");
  if (formulario) {
    var botonCompra = formulario.querySelector("[data-compra-boton]");
    var estado = formulario.querySelector("[data-compra-estado]");
    var foto = document.querySelector("[data-compra-foto]");
    var barraTexto = document.querySelector("[data-barra-texto]");
    var barraPrecio = document.querySelector("[data-barra-precio]");

    var actualizar = function () {
      var elegido = formulario.querySelector('input[name="id"]:checked');
      if (!elegido) return;
      var cantidad = Number(elegido.getAttribute("data-cantidad"));
      var precioTexto = elegido.getAttribute("data-precio-texto");
      var nombre = cantidad === 1 ? "1 unidad" : cantidad + " unidades";
      botonCompra.textContent = "Comprar " + nombre + " · " + precioTexto;
      if (foto) foto.setAttribute("data-cantidad", String(cantidad));
      if (barraTexto) barraTexto.textContent = nombre;
      if (barraPrecio) barraPrecio.textContent = precioTexto;
      if (estado) estado.textContent = "";
    };

    formulario.addEventListener("change", actualizar);
    actualizar();

    /* Si todavía no se ha elegido el producto en el editor del tema, la compra no se envía. */
    formulario.addEventListener("submit", function (ev) {
      if (formulario.getAttribute("data-sin-producto") !== "si") return;
      ev.preventDefault();
      estado.textContent = "La compra todavía no está activa. Vuelve a intentarlo en unos minutos o escríbenos por WhatsApp.";
    });
  }

  /* ---------- Barra de compra fija en celular ---------- */
  var barra = document.querySelector("[data-barra-compra]");
  var portada = document.querySelector("[data-portada]");
  var zonaCompra = document.getElementById("comprar");
  if (barra && portada && zonaCompra && "IntersectionObserver" in window) {
    var vePortada = true;
    var veCompra = false;
    var pintar = function () {
      barra.classList.toggle("es-visible", !vePortada && !veCompra);
    };
    new IntersectionObserver(function (e) {
      vePortada = e[0].isIntersecting;
      pintar();
    }).observe(portada);
    new IntersectionObserver(function (e) {
      veCompra = e[0].isIntersecting;
      pintar();
    }).observe(zonaCompra);
  }

  /* ---------- Formulario de contacto ---------- */
  var contacto = document.getElementById("formulario-contacto");
  if (contacto) {
    var mensajes = {
      nombre: "Escribe tu nombre para saber cómo llamarte.",
      correo: "Escribe un correo válido, por ejemplo nombre@correo.com.",
      mensaje: "Cuéntanos en qué te podemos ayudar.",
      autorizacion: "Para responderte necesitamos tu autorización de tratamiento de datos."
    };

    var validar = function (campo) {
      var error = document.getElementById(campo.id + "-error");
      var ok = campo.type === "checkbox" ? campo.checked : campo.checkValidity() && campo.value.trim() !== "";
      campo.setAttribute("aria-invalid", ok ? "false" : "true");
      if (error) error.textContent = ok ? "" : mensajes[campo.id] || "Revisa este campo.";
      return ok;
    };

    contacto.addEventListener("submit", function (ev) {
      var campos = contacto.querySelectorAll("[required]");
      var primero = null;
      Array.prototype.forEach.call(campos, function (campo) {
        if (!validar(campo) && !primero) primero = campo;
      });
      if (primero) {
        ev.preventDefault();
        primero.focus();
      }
    });

    contacto.addEventListener(
      "blur",
      function (ev) {
        if (ev.target.hasAttribute && ev.target.hasAttribute("required")) validar(ev.target);
      },
      true
    );
  }
})();
